import BaseValidator from 'services/validations/base-validator';

export default class PositionsNotDuplicatedValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {ruleItem, ruleName} = this.dependencies;

        const sameTeamPositions: string[] = [];
        const opposingTeamPositions: string[] = [];

        if (ruleItem.isStatementTypePosition()) {
            sameTeamPositions.push(ruleItem.getKeyPosition());
        }

        ruleItem.getBoostStatements().map((boostStatement) => {
            if (!boostStatement.isBoostForPosition()) {
                return;
            }

            boostStatement.getBoostedPositions().map((position) => {
                boostStatement.isSameTeam() ? sameTeamPositions.push(position) : opposingTeamPositions.push(position);
            });
        });

        if (sameTeamPositions.length > arrayUnique(sameTeamPositions).length) {
            this.addError(`Positions for the same team cannot be duplicated in ${ruleName}.`);
        } else if (opposingTeamPositions.length > arrayUnique(opposingTeamPositions).length) {
            this.addError(`Positions for the opposing team cannot be duplicated in ${ruleName}.`);
        }
    }
}
